import {
  locationIcon,
  place1Icon,
  place2Icon,
  place3Icon,
  starIcon,
  userIcon
} from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/championship.module.scss'

interface IProps {
  name: string | null
  photo: string | null
  score?: string | number | null
  isCurrentUser?: boolean
  place?: string | null
  city: string | null
  state: string | null
}

const ChampionshipMemberCard = ({
  name,
  photo,
  score = null,
  isCurrentUser,
  place = null,
  city,
  state
}: IProps): React.ReactElement => {
  const checkCity = city !== null && city !== ''
  const checkState = state !== null && state !== ''

  let address = ''

  if (!checkCity && !checkState) {
    address = 'Город не указан'
  } else if (checkCity && checkState) {
    address = `${city}, ${state}`
  } else if (checkCity) {
    address = city
  } else if (checkState) {
    address = state
  }

  let placeIcon = ''

  switch (place) {
    case '1': {
      placeIcon = place1Icon
      break
    }
    case '2': {
      placeIcon = place2Icon
      break
    }
    case '3': {
      placeIcon = place3Icon
      break
    }
    default: {
      placeIcon = ''
      break
    }
  }

  return (
    <div
      className={classNames({
        [style.member]: true,
        [style['member--current']]: isCurrentUser
      })}
    >
      <div className={style.member_info}>
        {place !== null
          ? (
            <span className={style.member__place}>
              {placeIcon !== ''
                ? (
                  <GxIcon src={placeIcon} className={style.member__place_icon} />
                  )
                : (
                    place
                  )}
            </span>
            )
          : null}
        {photo !== null && photo !== ''
          ? (
            <img
              src={photo}
              width='60px'
              height='60px'
              alt=''
              className={style.member__photo}
            />
            )
          : (
            <span className={style.member__icon_wrap}>
              <GxIcon src={userIcon} className={style.member__icon} />
            </span>
            )}

        <span className={style.member__name}>
          {name !== null ? name : 'Имя не указано'}
        </span>
      </div>
      <div className={style.member__score}>
        {score !== null
          ? (
            <>
              <GxIcon src={starIcon} className={style.member__score_icon} />
              {score}
            </>
            )
          : null}
      </div>
      <div className={style.member_location}>
        <GxIcon src={locationIcon} className={style.member__score_icon} />
        {address}
      </div>
    </div>
  )
}

export default ChampionshipMemberCard
